import React, { useRef, useState, useEffect, useMemo } from "react"
import { Link, useNavigate } from "react-router-dom"
import { APIServerIP } from "../../../helpers/Sats_api_helper"
import moment from "moment"
import {
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Form,
  Input,
  Label,
  Row,
  FormFeedback,
} from "reactstrap"

import "react-datepicker/dist/react-datepicker.css"

//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb"

//Validation
import * as Yup from "yup"
import { useFormik, Field } from "formik"

// Redux
import { useSelector, useDispatch } from "react-redux"

import {
  createTicket,
  updateTicket,
} from "../../../toolkitStore/ticketMSlice/ticketSlice"
import Switch from "react-switch"
import { fetchEventTypes } from "toolkitStore/eventTypeSlice"

function TicketEventForm(props) {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { isUserEdit } = useSelector(state => state.TicketReducer)

  const [image, SetImage] = useState()
  const [selectedData, SetSelectData] = useState()

  const event_id_c = JSON.parse(localStorage.getItem("event_id"))
  const eventTypesState = useSelector(state => state.eventTypes)
   const data = useMemo(() => eventTypesState?.data || [], [eventTypesState?.data])
  
    // Fetch data on mount
    useEffect(() => {
      dispatch(fetchEventTypes())
    }, [dispatch])

  useEffect(() => {
    if (isUserEdit) {
      const editUser = JSON.parse(localStorage.getItem("editUser"))
      SetSelectData(editUser)
    }
  }, [isUserEdit])
  //Cancel
  const Cancel = e => {
    e.preventDefault()
    localStorage.removeItem("editUser")
    SetSelectData("")
    navigate("/ticketeventlist")
  }

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      event_name: selectedData?.event_name || "",
      description: selectedData?.description || "",
      image_url: selectedData?.image_url || "",
      // event_type: selectedData?.event_type || [],
      event_type: selectedData?.event_type?.[0] || "",
      type: selectedData?.type || "",
      image_preview: selectedData?.image_preview || 0,
      no_of_days: selectedData?.no_of_days || "",
      // start_date: selectedData?.start_date
      //   ? moment.utc(selectedData.start_date).local().format("YYYY-MM-DDTHH:mm")
      //   : "",
      start_date: selectedData?.start_date
  ? moment(selectedData.start_date)
      .tz("America/Chicago")
      .format("YYYY-MM-DDTHH:mm")
  : "",

      enable_event_organizer: selectedData?.enable_event_organizer || false,
      event_organizer: selectedData?.event_organizer || [
        {
          organizer_name: "",
          contact_number: "",
          role: "",
          email: "",
        },
      ],
      active_status: selectedData?.active_status || "Active",
      publish_status: selectedData?.publish_status || "Draft",
      publish_status_id: selectedData?.public_status_id || 1,
    },
   validationSchema: Yup.object({
  event_name: Yup.string()
    .trim()
    .required("Event name is required"),

  description: Yup.string()
    .trim()
    .required("Description is required"),

  image_url: Yup.string()
    .required("Event image is required"),

event_type: Yup.string()
  .required("Event type is required"),

  no_of_days: Yup.number()
    .typeError("Number of days must be a number")
    .positive("Must be greater than 0")
    .integer("Must be a whole number")
    .required("Number of days is required"),

  start_date: Yup.string()
    .required("Start date & time is required"),

  enable_event_organizer: Yup.boolean(),

  event_organizer: Yup.array().when("enable_event_organizer", {
    is: true,
    then: schema =>
      schema
        .min(1, "At least one organizer is required")
        .of(
          Yup.object().shape({
            organizer_name: Yup.string()
              .trim()
              .required("Organizer name is required"),

            contact_number: Yup.string()
              .matches(/^[0-9]{7,15}$/, "Enter valid contact number")
              .required("Contact number is required"),

            role: Yup.string()
              .trim()
              .required("Role is required"),

            email: Yup.string()
              .email("Invalid email")
              .required("Email is required"),
          })
        ),
    otherwise: schema => schema.notRequired(),
  }),
}),
    onSubmit: (values, actions) => {
      const payload = {
        ...values,
         event_type: [values.event_type], 
        // start_date: moment(values.start_date).utc().toISOString(),
        start_date: moment.tz(values.start_date, "America/Chicago").toISOString(),
      }
      // if (selectedData?._id) {
      //   payload._id = selectedData._id
      //   dispatch(updateTicket(image, payload))
      // } else {
      //   dispatch(createTicket(image, payload))
      // }
        if (selectedData?._id) {
  payload._id = selectedData._id

  if (image instanceof File) {
     dispatch(updateTicket(image, payload))
  } else {
     dispatch(updateTicket(null, payload))
  }
} else {
  dispatch(createTicket(image, payload))
}
      console.log("ticket creation or updation log ---->", payload)

      navigate("/ticketeventlist")
    },
  })

  const RenderSwitchField = (label, fieldName, customOnChange = null) => {
    const getValue = path => {
      return path
        .split(/[.[\]]+/)
        .filter(Boolean)
        .reduce((acc, key) => acc?.[key], validation.values)
    }

    const isChecked =
      fieldName === "reserved" ? !!isReservedEnabled : !!getValue(fieldName)

    return (
      <div
        className="form-check form-switch mb-3 d-flex align-items-center justify-content-between px-0"
        onClick={e => e.stopPropagation()}
      >
        <Label className="mb-0">{label}</Label>

        <Switch
          checked={isChecked}
          onChange={checked => {
            if (customOnChange) {
              customOnChange(checked)
            } else {
              validation.setFieldValue(fieldName, checked)
            }
          }}
          onColor="#198754"
          uncheckedIcon={false}
          checkedIcon={false}
        />
      </div>
    )
  }

  const addOrganizer = () => {
  const event_organizer = [...validation.values.event_organizer]
 
  const lastOrganizer = event_organizer[event_organizer.length - 1]

  if (
    !lastOrganizer?.organizer_name ||
    !lastOrganizer?.contact_number ||
    !lastOrganizer?.role ||
    !lastOrganizer?.email
  ) {
    alert("Please fill existing organizer before adding new one")
    return
  }

  event_organizer.push({
    organizer_name: "",
    contact_number: "",
    role: "",
    email: "",
  })

  validation.setFieldValue("event_organizer", event_organizer)
}
  const removeOrganizer = index => {
    const event_organizer = [...validation.values.event_organizer]
    event_organizer.splice(index, 1)
    validation.setFieldValue("event_organizer", event_organizer)
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid> 
          
          <Breadcrumbs title="" breadcrumbItem="Event Ticket Information" />
          <Row>
            <Form
              onSubmit={event => {
                event.preventDefault()
                validation.handleSubmit()
              }}
            >
              <Card>
                <CardBody>
                  <div className="d-flex align-items-center border-bottom border-secondary pb-3">
                    <h5 className="mb-1 card-title flex-grow-1 text-primary ">
                      {event_id_c ? event_id_c.EventName : "New Event"}
                    </h5>
                    <div className="mb-1 flex-shrink-0">
                      <Link
                        to="/ticketeventlist"
                        className="btn btn-secondary me-1"
                      >
                        Back
                      </Link>
                      <Link
                        to="#!"
                        onClick={() => {
                          /*  dispatch(fetchServices(userInformation.m_company_id)) */
                        }}
                        className="btn btn-light me-1"
                      >
                        <i className="mdi mdi-refresh"></i>
                      </Link>
                    </div>
                  </div>

                  <Row className="mt-3 mb-3">
                    <Col lg={12} className="mb-3">
                      <div className="">
                        <Label htmlFor="event_name">Event Name</Label>
                        <Input
                          name="event_name"
                          className={`form-control`}
                          placeholder="Enter Event Name"
                          type="text"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.event_name || ""}
                          invalid={
                            validation.touched.event_name &&
                            validation.errors.event_name
                              ? true
                              : false
                          }
                        />
                        {validation.touched.event_name &&
                        validation.errors.event_name ? (
                          <FormFeedback
                            type="invalid"
                            style={{ fontSize: "12px" }}
                          >
                            {validation.errors.event_name}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </Col>
                    <Col lg={12} className="mb-3">
                      <div className="">
                        <Label htmlFor="description">
                          Event Short Description
                        </Label>
                        <Input
                          name="description"
                          className={`form-control`}
                          placeholder="Enter event description"
                          type="textarea"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.description || ""}
                          invalid={
                            validation.touched.description &&
                            validation.errors.description
                              ? true
                              : false
                          }
                        />
                        {validation.touched.description &&
                        validation.errors.description ? (
                          <FormFeedback
                            type="invalid"
                            style={{ fontSize: "12px" }}
                          >
                            {validation.errors.description}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </Col>

                     
                    <Col lg={6} className="">
                      <div className="">
                        <Label htmlFor="image_url">Event Photos</Label>
                        <Input
                          name="image_url"
                          className="form-control"
                          placeholder="Enter The Designation"
                          type="file"
                          onChange={e => {
                            validation.setFieldValue(
                              "image_url",
                              e.currentTarget.files[0].name
                            )
                            SetImage(e.currentTarget.files[0])
                          }}
                          invalid={
                            validation.touched.image_url &&
                            validation.errors.image_url
                              ? true
                              : false
                          }
                        />
                        {validation.touched.image_url &&
                        validation.errors.image_url ? (
                          <div
                            type="invalid"
                            className="invalid-feedback"
                            style={{ fontSize: "12px" }}
                          >
                            {validation.errors.image_url}
                          </div>
                        ) : selectedData?.image_url ? (
                          <a
                            href={`${APIServerIP}uploads/${selectedData?.image_url}`}
                          >
                            {selectedData?.image_url}
                          </a>
                        ) : (
                          validation.values.image_url
                        )}
                      </div>
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col>
  <div>
    <Label htmlFor="event_type">Event Type</Label>

    <select
      id="event_type"
      name="event_type"
      className={`form-select ${
        validation.touched.event_type && validation.errors.event_type
          ? "is-invalid"
          : ""
      }`}
      value={validation.values.event_type || ""}
      onChange={validation.handleChange}
    >
      <option value="">
        {data.length === 0 ? "Loading..." : "Select Event Type"}
      </option>

      {data.map((item) => (
        <option key={item._id} value={item.name}>
          {item.name}
        </option>
      ))}
    </select>

    {validation.touched.event_type &&
    validation.errors.event_type ? (
      <FormFeedback>{validation.errors.event_type}</FormFeedback>
    ) : null}
  </div>
</Col>
                    <Col>
                      <div className="">
                        <Label htmlFor="no_of_days">Number of days</Label>
                        <Input
                          name="no_of_days"
                          className={`form-control`}
                          placeholder="Number of days"
                          type="text"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.no_of_days || ""}
                          invalid={
                            validation.touched.no_of_days &&
                            validation.errors.no_of_days
                              ? true
                              : false
                          }
                        />
                        {validation.touched.no_of_days &&
                        validation.errors.no_of_days ? (
                          <FormFeedback
                            type="invalid"
                            style={{ fontSize: "12px" }}
                          >
                            {validation.errors.no_of_days}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </Col>
                    <Col>
                      <div className="">
                        <Label htmlFor="start_date">Start Date & Time</Label>
                        <Input
                          name="start_date"
                          className="form-control  "
                          placeholder="yyyy-mm-dd"
                          type="datetime-local"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.start_date || ""}
                          invalid={
                            validation.touched.start_date &&
                            validation.errors.start_date
                              ? true
                              : false
                          }
                        />
                        {validation.touched.start_date &&
                        validation.errors.start_date ? (
                          <FormFeedback type="invalid">
                            {validation.errors.start_date}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </Col>
                    {event_id_c && (
                      <Col>
                        <div className="">
                          <Label htmlFor="active_status"> Event Status </Label>
                          <select
                            id="active_status"
                            name="active_status"
                            className={`form-select ${
                              validation.touched.active_status &&
                              validation.errors.active_status &&
                              "is-invalid"
                            }`}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.active_status}
                          >
                            <option value={" "}>Select the status</option>
                            <option value={"Active"}>Active</option>
                            <option value={"Inactive"}>Inactive</option>
                          </select>
                          {validation.touched.active_status &&
                          validation.errors.active_status ? (
                            <FormFeedback>
                              {validation.errors.active_status}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                    )}
                  </Row>

                  <div className="card border-0 shadow-sm p-3">
                    <div className="d-flex justify-content-between align-items-center">
                      <span className="fw-semibold">Enable Event Organizers</span>
                      {RenderSwitchField("", "enable_event_organizer")}
                    </div>
                  </div>

                  {validation.values.enable_event_organizer && (
                    <div className="animate__animated animate__fadeIn mt-3">
                      {validation.values.event_organizer?.map((item, index) => (
                        <div
                          key={index}
                          className="p-3 mb-2 rounded bg-light border"
                        >
                          <Row className="g-2 align-items-center">
                            <Col md={2}>
                            <Label htmlFor="organizer_name"> Organizer Name </Label>


                              <Input
                                type="text"
                                placeholder="Organizer Name"
                                name={`event_organizer[${index}].organizer_name`}
                                value={item.organizer_name}
                                onChange={validation.handleChange}
                              />
                            </Col>

                            <Col md={2}>
                             <Label htmlFor="contact_number">Contact Number </Label>
                              <Input
                                type="text"
                                placeholder="Contact Number"
                                name={`event_organizer[${index}].contact_number`}
                                value={item.contact_number}
                                onChange={validation.handleChange}
                              />
                            </Col>

                            <Col md={2}>
                            <Label htmlFor="role">Role </Label>
                              <Input
                                type="text"
                                placeholder="Role"
                                name={`event_organizer[${index}].role`}
                                value={item.role}
                                onChange={validation.handleChange}
                              />
                            </Col>
                            <Col md={3}>
                            <Label htmlFor="email">Email ID</Label>
                              <Input
                                type="email"
                                placeholder="Email"
                                name={`event_organizer[${index}].email`}
                                value={item.email}
                                onChange={validation.handleChange}
                              />
                            </Col>

                            <Col md={1} className="text-end">
                              <button
                                type="button"
                                className="btn btn-link text-danger p-0"
                                onClick={() => removeOrganizer(index)}
                              >
                                <i className="mdi mdi-delete-outline fs-5"></i>
                              </button>
                            </Col>
                          </Row>
                        </div>
                      ))}

                      <button
                        type="button"
                        className="btn btn-outline-dark btn-sm mt-1"
                        onClick={addOrganizer}
                      >
                        <i className="mdi mdi-plus-circle-outline me-1"></i>
                        Add Organizer
                      </button>
                    </div>
                  )}

                  <Col className="d-flex mt-3 justify-content-end">
                    <div className=" text-center mt-3 ">
                      <button
                        type="submit"
                        className="btn btn-success w-md px-5"
                      >
                        {selectedData?._id ? "Update" : "Submit"}
                      </button>
                    </div>
                    <div className=" text-center mt-3 mx-3 ">
                      <button
                        onClick={Cancel}
                        className="btn btn-danger w-md px-5"
                      >
                        {"Cancel"}
                      </button>
                    </div>
                  </Col>
                </CardBody>
              </Card>
            </Form>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default TicketEventForm
